import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import PropTypes from 'prop-types';
import moment from 'moment';


//Material Components
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import { Fab, IconButton, InputAdornment, TextField } from '@material-ui/core';

import { Button, ButtonGroup } from '@material-ui/core';


import Modal from '@material-ui/core/Modal'
import Paper from '@material-ui/core/Paper'
import { sweetAlert } from '../../components/Alert/sweetAlert';

//Engage Components
import {
    RenderImageLoader,
    renderTextField,
    renderTextFieldWithChips,
    SimpleCard,
    renderSingleDatePicker,
    ActivityChevronList,
    renderActivitySwitch,
    renderSelect
} from '../../utils/engageComponents';
import RecurrenceModal from '../../components/RecurrenceModal/RecurrenceModal'

//Actions
import { GetCategoriesByCommunityId } from '../../actions/categoryActions'
import { AddActivity, UpdActivity, AddDetailsImage } from '../../actions/activityAction'
import { getCommunityByIdAsync } from '../../actions/communityActions';

import {
    ADD_ACTIVITY_SUCCESS,
    UPDATE_ACTIVITY_SUCCESS
} from '../../constants/activitiesConstants';

//Views
import ActivityPreview from '../activities/ActivityPreview'

//Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLanguage } from '@fortawesome/free-solid-svg-icons';
import { Clear, SearchRounded } from '@material-ui/icons';
import { GetPixabyImages, ClearImages } from '../../actions/imageActions';
import ImagesModal from '../../components/Images/ImagesModal';
import UpdateRecurrenceConfirmation from './UpdateRecurrenceConfirmation';


const validate = (values) => {
    const errors = {};

    if (values.Content) {

        if (!values.Content.location) {
            if (!errors.Content) {
                errors.Content = {};
            }

            errors.Content.location = 'please add location';
        }

        if (!values.Content.title) {
            if (!errors.Content) {
                errors.Content = {};
            }

            errors.Content.title = 'please add title';
        } else if (values.Content.title.length > 50) {
            if (!errors.Content) {
                errors.Content = {};
            }

            errors.Content.title = 'Title must have less than 50 characters';
        }

        if (values.Content.description && values.Content.description.length > 150) {
            if (!errors.Content) {
                errors.Content = {};
            }

            errors.Content.description = 'Description must have less than 150 characters';
        }


        if (!values.Content.category) {
            if (!errors.Content) {
                errors.Content = {};
            }

            errors.Content.category = 'please select a category';
        }


        if (values.Content.titleEs) {
            if (values.Content.titleEs.length > 50) {
                if (!errors.Content) {
                    errors.Content = {};
                }

                errors.Content.titleEs = 'Title Esp must have less than 50 characters';
            }
        }

        if (values.Content.descriptionEs) {
            if (values.Content.descriptionEs.length > 150) {
                if (!errors.Content) {
                    errors.Content = {};
                }

                errors.Content.descriptionEs = 'Description Esp must have less than 150 characters';
            }
        }

        if (values.Content.titleFr) {
            if (values.Content.titleFr.length > 50) {
                if (!errors.Content) {
                    errors.Content = {};
                }

                errors.Content.titleFr = 'Title Fr must have less than 50 characters';
            }
        }

        if (values.Content.descriptionFr) {
            if (values.Content.descriptionFr.length > 150) {
                if (!errors.Content) {
                    errors.Content = {};
                }

                errors.Content.descriptionFr = 'Description Fr must have less than 150 characters';
            }
        }

    } else {
        errors.Content = {};

        errors.Content.location = 'please add location';
        errors.Content.title = 'please add title';
        errors.Content.category = 'please select a category';
    }

    return errors;
};


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};


TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};



export class AddEditActivityV2 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            _id: (props.data && props.data._id) ? this.props.data._id : undefined,
            action: (props.data && props.data._id) ? 'edit' : 'new',
            renderNeeded: false,
            //CommunityId
            communityId: (localStorage && localStorage.getItem('communityId')) ? localStorage.getItem('communityId') : undefined,
            communityData: undefined,
            //Tabs
            tabValue: 0,
            //textFielWithChips
            chipsArray: (props.data && props.data.tags) ? props.data.tags : [],
            chipTextFieldActualText: '',
            //General Info
            startDate: (props.data && props.data.date) ? props.data.date : this.GetUTCDate(new Date()),
            endDate: (props.data && props.data.endDate) ? props.data.endDate : this.GetUTCDate(new Date()),
            maxAttendees: (props.data && props.data.maxAttendees) ? props.data.maxAttendees : '',
            //Logistics
            title: (props.data && props.data.title) ? props.data.title : undefined,
            description: (props.data && props.data.description) ? props.data.description : undefined,
            location: (props.data && props.data.location) ? props.data.location : undefined,
            transportation: (props.data && props.data.transportation) ? props.data.transportation : false,
            hideOnPrint: (props.data && props.data.hideOnPrinting) ? props.data.hideOnPrinting : false,
            translationTab: 0,
            titleEs: undefined,
            descriptionEs: undefined,
            titleFr: undefined,
            descriptionFr: undefined,
            openTranslationsModal: false,
            //Category
            categorySelected: undefined,
            category: (props.data && props.data.category) ? props.data.category : undefined,
            //Theme
            selectedTheme: undefined,
            //Details Image
            // selectedDetailsImage: (props.data && props.data.imageUrl) ? props.data.imageUrl : undefined,
            selectedDetailsImageObj: undefined,
            selectedDetailsImageUrl: (props.data && props.data.imageUrl) ? props.data.imageUrl : undefined,
            objBase64selectedDetailsImage: undefined,
            //ThumbnailIcon
            selectedThumbnailIcon: undefined,
            //Modal Recurrence
            isUpdSchedule: true,
            openModal: false,
            recurrenceType: (props.data && props.data.scheduleData && props.data.scheduleData.recurrenceType) ? props.data.scheduleData.recurrenceType : undefined,
            modalSunday: (props.data && props.data.scheduleData && props.data.scheduleData.sunday) ? props.data.scheduleData.sunday : false,
            modalMonday: (props.data && props.data.scheduleData && props.data.scheduleData.monday) ? props.data.scheduleData.monday : false,
            modalTuesday: (props.data && props.data.scheduleData && props.data.scheduleData.tuesday) ? props.data.scheduleData.tuesday : false,
            modalWednesday: (props.data && props.data.scheduleData && props.data.scheduleData.wednesday) ? props.data.scheduleData.wednesday : false,
            modalThursday: (props.data && props.data.scheduleData && props.data.scheduleData.thursday) ? props.data.scheduleData.thursday : false,
            modalFriday: (props.data && props.data.scheduleData && props.data.scheduleData.friday) ? props.data.scheduleData.friday : false,
            modalSaturday: (props.data && props.data.scheduleData && props.data.scheduleData.saturday) ? props.data.scheduleData.saturday : false,
            endRecurrenceDate: (props.data && props.data.scheduleData && props.data.scheduleData.endDate) ? new Date(props.data.scheduleData.endDate) : this.GetUTCDate(new Date()),
            recurrenceUpdate: false,
            openModalRecurrenceUpdate: false,
            openCategoryCombo: false,
            openThumbnailCombo: false,

            //dateFormat
            dateFormat: 'MMMM dd, yyyy',
            dateFormatActivity: 'MMMM dd, yyyy',
            tzName: props.tzName,

            startMeridem: (props.data && props.data.date) ? this.GetHoursMeridem(props.data.date) : 0,
            endMeridem: (props.data && props.data.endDate) ? this.GetHoursMeridem(props.data.endDate) : 0,
            startHour: (props.data && props.data.date) ? this.GetHoursMinutes(props.data.date, props.tzName, 'H') : {},
            startMin: (props.data && props.data.date) ? this.GetHoursMinutes(props.data.date, props.tzName, 'M') : {},
            endHour: (props.data && props.data.endDate) ? this.GetHoursMinutes(props.data.endDate, props.tzName, 'H') : {},
            endMin: (props.data && props.data.endDate) ? this.GetHoursMinutes(props.data.endDate, props.tzName, 'M') : {},
            updEndDate: false,

            //Recurrence Modal
            recurrenceObj: (props && props.data && props.data.scheduleData) ? this.GetRecurrenceObjInLoading(props.data.scheduleData, (props.data && props.data.date) ? props.data.date : this.GetUTCDate(new Date())) : { StartDate: (props && props.data && props.data.startDate) ? props.data.startDate : new Date() },
            openRecurrenceModal: false,

            RepeatValue: (props && props.data && props.data.scheduleData && props.data.scheduleData.customRepeatValue) ? { name: props.data.scheduleData.customRepeatValue } : { name: 'Does not repeat' },
            RepeatValueOptions: [{ name: 'Does not repeat' }, { name: 'Daily' }, { name: 'Weekly' }, { name: 'Monthly' }, { name: 'Yearly' }],
            recurrenceCleanInfo: (props && props.data && props.data.scheduleData && props.data.scheduleData.endDateForRecurrency) ? false : true,
            recurrenceInitialValue: (props && props.data && props.data.scheduleData && props.data.scheduleData.customRepeatValue) ? { name: props.data.scheduleData.customRepeatValue } : { name: 'Does not repeat' },
            imageSearch: '',
            openSearchModal: false,

        };

        if (props.data) {
            //GENERAL INFO
            this.props.dispatch(change('ActivityForm', '_id', props.data._id ? props.data._id : ''));
            this.props.dispatch(change('ActivityForm', 'Content.title', props.data.title ? props.data.title : ''));
            this.props.dispatch(change('ActivityForm', 'Content.description', props.data.description ? props.data.description : ''));
            this.props.dispatch(change('ActivityForm', 'Content.startDate', props.data.date ? props.data.date : this.GetUTCDate(new Date())));
            this.props.dispatch(change('ActivityForm', 'Content.endDate', props.data.endDate ? props.data.endDate : this.GetUTCDate(new Date())));
            this.props.dispatch(change('ActivityForm', 'Content.maxAttendees', props.data.maxAttendees ? props.data.maxAttendees : ''));

            //LOGISTICS
            this.props.dispatch(change('ActivityForm', 'Content.location', props.data.location ? props.data.location : ''));
            this.props.dispatch(change('ActivityForm', 'Content.transportation', props.data.transportation ? props.data.transportation : false));
            this.props.dispatch(change('ActivityForm', 'Content.detailsImageUrl', props.data.detailsImageUrl ? props.data.detailsImageUrl : ''));

            //IDENTIFIERS
            this.props.dispatch(change('ActivityForm', 'Content.identifiers', props.data.Identifiers ? props.data.Identifiers : ''));
            this.props.dispatch(change('ActivityForm', 'Content.category', props.data.category ? props.data.category : ''));

            //Design.Thumbnail
            //this.props.dispatch(change('ActivityForm','Desing.thumbnailText', props.data.content? props.data.content: ''));
            this.props.dispatch(change('ActivityForm', 'Desing.thumbnailIcon', props.data.iconUrl ? props.data.iconUrl : ''));
            this.props.dispatch(change('ActivityForm', 'Desing.thumbnailIconObject', ''));

            //Recurrence
            this.props.dispatch(change('ActivityForm', 'Recurrence.recurrenceType', (props.data.scheduleData && props.data.scheduleData.recurrenceType) ? props.data.scheduleData.recurrenceType : undefined));
            this.props.dispatch(change('ActivityForm', 'Recurrence.endDate', (props.data.scheduleData && props.data.scheduleData.endDate) ? new Date(props.data.scheduleData.endDate) : this.GetUTCDate(new Date())));
            this.props.dispatch(change('ActivityForm', 'Recurrence.sunday', (props.data.scheduleData && props.data.scheduleData.sunday) ? props.data.scheduleData.sunday : ''));
            this.props.dispatch(change('ActivityForm', 'Recurrence.monday', (props.data.scheduleData && props.data.scheduleData.monday) ? props.data.scheduleData.monday : ''));
            this.props.dispatch(change('ActivityForm', 'Recurrence.tuesday', (props.data.scheduleData && props.data.scheduleData.tuesday) ? props.data.scheduleData.tuesday : ''));
            this.props.dispatch(change('ActivityForm', 'Recurrence.wednesday', (props.data.scheduleData && props.data.scheduleData.wednesday) ? props.data.scheduleData.wednesday : ''));
            this.props.dispatch(change('ActivityForm', 'Recurrence.thursday', (props.data.scheduleData && props.data.scheduleData.thursday) ? props.data.scheduleData.thursday : ''));
            this.props.dispatch(change('ActivityForm', 'Recurrence.friday', (props.data.scheduleData && props.data.scheduleData.friday) ? props.data.scheduleData.friday : ''));
            this.props.dispatch(change('ActivityForm', 'Recurrence.saturday', (props.data.scheduleData && props.data.scheduleData.saturday) ? props.data.scheduleData.saturday : ''));

        } else {

            //GENERAL INFO
            this.props.dispatch(change('ActivityForm', '_id', ''));
            this.props.dispatch(change('ActivityForm', 'Content.title', ''));
            this.props.dispatch(change('ActivityForm', 'Content.description', ''));
            this.props.dispatch(change('ActivityForm', 'Content.startDate', this.GetUTCDate(new Date())));
            this.props.dispatch(change('ActivityForm', 'Content.endDate', this.GetUTCDate(new Date())));
            this.props.dispatch(change('ActivityForm', 'Content.maxAttendees', ''));

            //LOGISTICS
            this.props.dispatch(change('ActivityForm', 'Content.location', ''));
            this.props.dispatch(change('ActivityForm', 'Content.transportation', false));
            this.props.dispatch(change('ActivityForm', 'Content.detailsImageUrl', ''));

            //IDENTIFIERS
            this.props.dispatch(change('ActivityForm', 'Content.identifiers', ''));
            this.props.dispatch(change('ActivityForm', 'Content.category', ''));

            //Design.Thumbnail
            //this.props.dispatch(change('ActivityForm','Desing.thumbnailText',''));
            this.props.dispatch(change('ActivityForm', 'Desing.thumbnailIcon', ''));
            this.props.dispatch(change('ActivityForm', 'Desing.thumbnailIconObject', ''));

            //Recurrence
            this.props.dispatch(change('ActivityForm', 'Recurrence.recurrenceType', ''));
            //this.props.dispatch(change('ActivityForm','Recurrence.recurrenceNoEnd', ''));
            this.props.dispatch(change('ActivityForm', 'Recurrence.endDate', this.GetUTCDate(new Date())));
            this.props.dispatch(change('ActivityForm', 'Recurrence.sunday', ''));
            this.props.dispatch(change('ActivityForm', 'Recurrence.monday', ''));
            this.props.dispatch(change('ActivityForm', 'Recurrence.tuesday', ''));
            this.props.dispatch(change('ActivityForm', 'Recurrence.wednesday', ''));
            this.props.dispatch(change('ActivityForm', 'Recurrence.thursday', ''));
            this.props.dispatch(change('ActivityForm', 'Recurrence.friday', ''));
            this.props.dispatch(change('ActivityForm', 'Recurrence.saturday', ''));

        }

    }

    GetRecurrenceObjInLoading = (scheduleData, startDate) => {
        try {
            const {
                customEndOcurrences,
                customEndOption,
                customRepeatInterval,
                customRepeatValue,
                endDateForRecurrency,
                MonthValue,
                weeklyRecurrence,
                customMonthlyDayNumber,
                customMonthlyOptionSelected,
                customSelectedMonthlyRepetitionDay,
                customSelectedMonthlyOrdinalPosition,
                OccurrenceLabel
            } = scheduleData

            let newRecurrenceObj = {
                OccurrencesField: customEndOcurrences ? customEndOcurrences : 1,
                RepeatInterval: customRepeatInterval ? customRepeatInterval : 1,
                RepeatValue: customRepeatValue ? { name: customRepeatValue } : { name: 'Daily' },
                selectedWeekDays: weeklyRecurrence ? weeklyRecurrence : [],
                endDateForRecurrency: endDateForRecurrency ? endDateForRecurrency : undefined,
                EndSelection: customEndOption ? customEndOption : undefined,
                customMonthlyDayNumber: customMonthlyDayNumber ? customMonthlyDayNumber : undefined,
                customMonthlyOptionSelected: customMonthlyOptionSelected ? customMonthlyOptionSelected : undefined,
                customSelectedMonthlyRepetitionDay: customSelectedMonthlyRepetitionDay ? customSelectedMonthlyRepetitionDay : undefined,
                customSelectedMonthlyOrdinalPosition: customSelectedMonthlyOrdinalPosition ? customSelectedMonthlyOrdinalPosition : undefined,
                StartDate: startDate,
                MonthValue: MonthValue,
                OccurrenceLabel: OccurrenceLabel
            }

            return newRecurrenceObj;
        } catch (err) {
            return { StartDate: new Date() }
        }
    }

    async GetCommunityDataByCommunityId(communityId) {
        let communityData = undefined;

        if (communityId) {

            communityData = await this.props.getCommunityByIdAsync(communityId);

            if (communityData[0].timeZoneName) {
                const startDate = this.GetDateChangingTimeZone(this.state.startDate, this.state.tzName);
                const endDate = this.GetDateChangingTimeZone(this.state.endDate, this.state.tzName);

                this.setState({
                    communityData: communityData[0],
                    startDate: startDate,
                    endDate: endDate,
                })
            } else {
                this.setState({
                    communityData: communityData,
                })
            }

        }

        return communityData;
    };

    GetDateChangingTimeZone(date, timeZoneName) {

        let provisionalDate = new Date();

        if (date && timeZoneName) {
            if (date) {
                provisionalDate = new Date(new Date(date).toLocaleString("en-US", { timeZone: timeZoneName }));
            }
        }
        else {
            provisionalDate = date;
        }

        return provisionalDate;
    };

    componentDidMount() {

        if(this.props.data){
            document.title='Activities - Edit Activity'

        }else{
            document.title='Activities - Add Activity'

        }

        const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;
        if (communityId) {
            this.props.GetCategoriesByCommunityId(communityId);
        }

        if (localStorage.getItem('communityId')) {
            this.GetCommunityDataByCommunityId(localStorage.getItem('communityId'));
        }

        //Select the first category by default when is add activity   
        if (this.props.categoryData && this.props.categoryData.length > 0 && !this.props.data) {
            this.setState({ categorySelected: this.props.categoryData[0] });
            this.props.dispatch(change('ActivityForm', 'Content.category', this.props.categoryData[0]));

        }

        //This is to sort the attendees by last name
        if (this.props.data && this.props.data.attendees && this.props.data.attendees.length > 0) {
            this.props.data.attendees.sort((a, b) => {
                let x = a.name.split(' ')[1].toLowerCase();
                let y = b.name.split(' ')[1].toLowerCase();
                if (x < y) { return -1; }
                if (x > y) { return 1; }
                return 0;
            });
        }


        if (this.props.data && this.props.data.imageUrl && this.props.images) {

            const imgObj = this.props.images.find(i => i.imageUrl === this.props.data.imageUrl)
            this.setState({ selectedDetailsImageObj: imgObj })
        }

        if (this.props.data?.translations && this.props.data.translations.length > 0) {

            const frenchObj = this.props.data.translations.find(x => x.languageCode === 'fr');
            const spanishObj = this.props.data.translations.find(x => x.languageCode === 'es');


            if (spanishObj) {
                this.setState({ titleEs: spanishObj.title, descriptionEs: spanishObj.description });

                this.props.dispatch(change('ActivityForm', 'Content.titleEs', spanishObj.title));
                this.props.dispatch(change('ActivityForm', 'Content.descriptionEs', spanishObj.description));

            }

            if (frenchObj) {
                this.setState({ titleFr: frenchObj.title, descriptionFr: frenchObj.description });

                this.props.dispatch(change('ActivityForm', 'Content.titleFr', frenchObj.title));
                this.props.dispatch(change('ActivityForm', 'Content.descriptionFr', frenchObj.description));

            }

        }

    }

    clearState() {
        this.setState({
            _id: undefined,
            //textFielWithChips
            chipsArray: [],
            chipTextFieldActualText: '',
            //General Info
            startDate: this.GetUTCDate(new Date()),
            endDate: this.GetUTCDate(new Date()),
            //Logistics
            transportation: false,
            //Category
            categorySelected: undefined,
            category: undefined,
            //Theme
            selectedTheme: undefined,
            //Details Image
            selectedDetailsImageUrl: (this.props.data && this.props.data.imageUrl) ? this.props.data.imageUrl : undefined,
            objBase64selectedDetailsImage: undefined,
            selectedDetailsImageObj: undefined,
            //CommunityId
            communityId: localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined,

            recurrenceType: undefined,
            recurrenceNoEnd: false,
            modalSunday: false,
            modalMonday: false,
            modalTuesday: false,
            modalWednesday: false,
            modalThursday: false,
            modalFriday: false,
            modalSaturday: false,
        });

    }

    cleanModal = () => {
        this.setState({
            openModal: false,
        });
    };

    GetRecurrenceObject = () => {
        try {
            let recurrencyObject = undefined;

            const {
                EndSelection,
                MonthValue,
                RepeatInterval,
                OccurrencesField,
                RepeatValue,
                StartDate,
                selectedWeekDays,
                endDateForRecurrency,
                customMonthlyOptionSelected,
                customMonthlyDayNumber,
                customSelectedMonthlyOrdinalPosition,
                customSelectedMonthlyRepetitionDay,
                OccurrenceLabel,
                initialRecurrenceDate
            } = this.state.recurrenceObj;

            const newOccurrences = (OccurrencesField && OccurrencesField > 0) ? OccurrencesField : 1
            if (!RepeatValue || !RepeatInterval) {
                return undefined;
            }

            let repetitionLabel = 'days';

            switch (RepeatValue.name) {
                case 'Daily': repetitionLabel = 'days'; break;
                case 'Weekly': repetitionLabel = 'weeks'; break;
                case 'Monthly': repetitionLabel = 'months'; break;
                case 'Yearly': repetitionLabel = 'years'; break;
                default: repetitionLabel = 'days'; break;
            }

            let newEndData = undefined;

            if (StartDate && EndSelection && EndSelection.name === 'After') {
                newEndData = moment(StartDate);

                newEndData = newEndData.add(RepeatInterval * (newOccurrences - 1), repetitionLabel);
            } else if (StartDate && EndSelection && EndSelection.name === 'On this date' && endDateForRecurrency) {
                newEndData = endDateForRecurrency;
            }

            let endDate = (newEndData && StartDate && new moment(StartDate) < new moment(newEndData)) ? new Date(newEndData) : undefined;

            const recurrencyType = { name: 'Custom' };
            const weeklyRecurrence = selectedWeekDays ? selectedWeekDays : undefined;

            const customRepeatInterval = RepeatInterval ? RepeatInterval : undefined;
            const customRepeatValue = RepeatValue ? RepeatValue : undefined;

            if (
                endDate &&
                recurrencyType &&
                (

                    (
                        recurrencyType.name.toLowerCase() === 'custom' &&
                        customRepeatInterval &&
                        customRepeatValue

                    )
                )
            ) {

                recurrencyObject = {
                    endDateForRecurrency: endDateForRecurrency,
                    recurrencyType: recurrencyType,
                    weeklyRecurrence: weeklyRecurrence,
                    MonthValue: MonthValue,
                    customRepeatInterval: customRepeatInterval,
                    customRepeatValue: customRepeatValue.name,
                    customEndOption: EndSelection,
                    customEndOcurrences: newOccurrences,
                    customMonthlyOptionSelected: customMonthlyOptionSelected,
                    customMonthlyDayNumber: customMonthlyDayNumber,
                    customSelectedMonthlyOrdinalPosition: customSelectedMonthlyOrdinalPosition,
                    customSelectedMonthlyRepetitionDay: customSelectedMonthlyRepetitionDay,
                    OccurrenceLabel: OccurrenceLabel,
                    initialRecurrenceDate: initialRecurrenceDate
                }
            }

            return recurrencyObject;
        } catch (err) {
            return undefined
        }
    }


    async onSubmitHandler(formData) {


        if (this.props.activityForm && this.props.activityForm.ActivityForm && !this.props.activityForm.ActivityForm.syncErrors) {

            let page = this.props.currentPage;

            if (this.state.categorySelected && this.state.categorySelected._id && (!this.state.categorySelected.categotyId || this.state.categorySelected.categotyId === '')) {

                const categoryId = this.state.categorySelected._id;
                this.state.categorySelected.categoryId = categoryId;
            }

            let objToSend = {}
            objToSend._id = formData._id ? formData._id : undefined;
            objToSend.type = 1;
            objToSend.communityId = this.state.communityId ? this.state.communityId : ''; // TODO make it dinamyc
            objToSend.title = (formData.Content && formData.Content.title) ? formData.Content.title : '';
            objToSend.name = (formData.Content && formData.Content.title) ? formData.Content.title : '';
            objToSend.description = (formData.Content && formData.Content.description) ? formData.Content.description : '';
            objToSend.location = (formData.Content && formData.Content.location) ? formData.Content.location : '';

            objToSend.date = this.state.startDate;
            objToSend.endDate = this.state.endDate;

            if (objToSend.date < new Date()) {
                sweetAlert('error', 'Start date must be greater than the current date', 'alert_AddEditActivity_Date_Error');
                this.setState({ tabValue: 0 })
                return;
            }

            if (objToSend.endDate < objToSend.date) {
                sweetAlert('error', 'Start date must be greater than the end date', 'alert_AddEditActivity_Date_Error');
                this.setState({ tabValue: 0 })
                return;
            }

            objToSend.category = this.state.categorySelected;
            objToSend.maxAttendees = this.state.maxAttendees;

            if (!objToSend.category) {
                sweetAlert('error', 'Please select a category', 'alert_AddEditActivity_Category_Error');
                this.setState({ tabValue: 0 })
                return;
            }

            if (objToSend.maxAttendees.length <= 0) {
                objToSend.maxAttendees = null;
            } else if (objToSend.maxAttendees === 0) {
                sweetAlert('error', 'The activity’s max attendees should be more than 0', 'alert_AddEditActivity_MaxAttendees_Error');
                return;
            }

            objToSend.transportation = this.state.transportation;
            objToSend.tags = (this.state.chipsArray) ? this.state.chipsArray : [];
            objToSend.timeDuration = this.GetDiff(new Date(this.state.startDate), new Date(this.state.endDate))
            objToSend.content = (formData.Content && formData.Content.title) ? formData.Content.title : '';

            if (objToSend.timeDuration === 0) {
                sweetAlert('error', 'Time duration should be more than 0', 'alert_AddEditActivity_TimeDuration_Error');
                return;
            }

            //objToSend.subTitleContent = formData.Desing.thumbnailSubtext? formData.Desing.thumbnailSubtext : '';//Thumbnail Subtext (subTitleContent)
            //Set if the recurrence has updates or not
            objToSend.recurrenceUpdate = this.state.recurrenceUpdate

            if (this.state.recurrenceType) {
                const placeHolderDate = this.state.startDate ? new Date(this.state.startDate) : undefined;

                objToSend.scheduleData = {};

                objToSend.scheduleData.recurrenceType = this.state.recurrenceType ? this.state.recurrenceType : ((this.props.data.recurrence && this.props.data.recurrence.recurrenceType) ? this.props.data.recurrence.recurrenceType : undefined);
                objToSend.scheduleData.endDate = this.state.endRecurrenceDate ? this.state.endRecurrenceDate : ((this.props.data.recurrence && this.props.data.recurrence.endDate) ? this.props.data.recurrence.endDate : placeHolderDate);
                const endDate = new Date(objToSend.scheduleData.endDate);
                if (endDate) {
                    objToSend.scheduleData.endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59);
                }


                objToSend.scheduleData.sunday = this.state.modalSunday;
                objToSend.scheduleData.monday = this.state.modalMonday;
                objToSend.scheduleData.tuesday = this.state.modalTuesday;
                objToSend.scheduleData.wednesday = this.state.modalWednesday;
                objToSend.scheduleData.thursday = this.state.modalThursday;
                objToSend.scheduleData.friday = this.state.modalFriday;
                objToSend.scheduleData.saturday = this.state.modalSaturday;

                objToSend.recurrenceUpdate = this.state.recurrenceUpdate;

                if (this.props.data && !this.props.data.scheduleData) {
                    objToSend.recurrenceUpdate = true;
                }
            }

            if (this.props.data && this.props.data.scheduleId) {
                objToSend.scheduleId = this.props.data.scheduleId
            }

            //Recurrence
            if (this.state.recurrenceObj) {
                //Get newScheduleData
                const newScheduleData = this.GetRecurrenceObject();
                if (newScheduleData) {
                    objToSend.scheduleData = newScheduleData;

                    if (newScheduleData.initialRecurrenceDate !== undefined) {
                        objToSend.date = new Date(objToSend.date.setFullYear(newScheduleData.initialRecurrenceDate.getFullYear(), newScheduleData.initialRecurrenceDate.getMonth(), newScheduleData.initialRecurrenceDate.getDate()));
                        objToSend.endDate = new Date(objToSend.endDate.setFullYear(newScheduleData.initialRecurrenceDate.getFullYear(), newScheduleData.initialRecurrenceDate.getMonth(), newScheduleData.initialRecurrenceDate.getDate()));
                    }

                    if (this.props.data && !this.props.data.scheduleData.endDateForRecurrency) {
                        objToSend.recurrenceUpdate = true;
                    }
                }
            }
            //Images Urls
            //Theme
            objToSend.activityUrl = (this.state.selectedTheme && this.state.selectedTheme.iconUrl) ? this.state.selectedTheme.iconUrl : '';
            objToSend.backgroundUrl = (this.state.selectedTheme && this.state.selectedTheme.iconUrl) ? this.state.selectedTheme.iconUrl : '';

            //IconUrl
            objToSend.iconUrl = (this.state.selectedThumbnailIcon && this.state.selectedThumbnailIcon.iconUrl) ? this.state.selectedThumbnailIcon.iconUrl : '';
            objToSend.activityResourceName = (this.state.selectedThumbnailIcon && this.state.selectedThumbnailIcon.name) ? this.state.selectedThumbnailIcon.name : '';

            //Details Image
            objToSend.imageUrl = this.state.selectedDetailsImageUrl;
            // objToSend.imageUrl = '';
            let objImage = {};


            const img = this.props.images.find(i => i.imageUrl === this.state.selectedDetailsImageUrl); //Find if the image is already uploaded

            if (!img && this.state.objBase64selectedDetailsImage && this.state.objBase64selectedDetailsImage.file && this.state.selectedDetailsImageUrl) {
                //Call Update Image to Server Await
                objImage = await this.props.AddDetailsImage(this.state.objBase64selectedDetailsImage, localStorage.getItem('communityId'))
                objToSend.imageUrl = objImage.url;
                objToSend.thumbnailImageUrl = objImage.url;
            }

            //Thumbnail Image
            objToSend.thumbnailImageUrl = objToSend.imageUrl;


            //setting sDateTime
            //const sDateTime = new Date( objToSend.date.toLocaleString("en-US", {timeZone:'utc'}) )
            const sYear = objToSend.date.getFullYear();
            const sMonth = ('0' + (objToSend.date.getMonth() + 1)).slice(-2);
            const sDate = ('0' + objToSend.date.getDate()).slice(-2);
            const sHour = ('0' + objToSend.date.getHours()).slice(-2);
            const sMinute = ('0' + objToSend.date.getMinutes()).slice(-2);
            const sDateTime = sYear + '-' + sMonth + '-' + sDate + 'T' + sHour + ':' + sMinute + ':00.000Z'

            objToSend.sDateTime = sDateTime;

            objToSend.translations = [];

            if (this.state.titleEs !== '' && this.state.descriptionEs !== '') {
                const spanishObj = {
                    languageCode: 'es',
                    title: this.state.titleEs,
                    description: this.state.descriptionEs
                }

                objToSend.translations.push(spanishObj);
            }

            if (this.state.titleFr !== '' && this.state.descriptionFr !== '') {
                const frenchObj = {
                    languageCode: 'fr',
                    title: this.state.titleFr,
                    description: this.state.descriptionFr
                }

                objToSend.translations.push(frenchObj);
            }

            objToSend.hideOnPrinting = this.state.hideOnPrint

            setTimeout(() => {

                if (this.state._id && this.state._id.length > 0) {
                    //is Upd
                    this.props.UpdActivity(this.state._id, objToSend, localStorage.getItem('communityId'));
                } else {
                    //is Add

                    if (this.props.activityData) {
                        let objToSort = { ...objToSend };
                        objToSort.isTheOne = true;

                        let addActivityData = this.props.activityData ? [...this.props.activityData.data] : []
                        addActivityData.push(objToSort);
                        addActivityData.sort((a, b) => {

                            if (new Date(a.date) > new Date(b.date)) {
                                return 1;
                            } else {
                                return -1;
                            }
                        });

                        const objIndexOnSorterdArray = addActivityData.findIndex(item => item.isTheOne === true);
                        const pageOfNewItem = Math.ceil(((objIndexOnSorterdArray > 0 ? objIndexOnSorterdArray : 0) + 1) / (this.props.itemPerPage ? this.props.itemPerPage : 5));

                        page = pageOfNewItem;
                    }

                    this.props.AddActivity(objToSend, localStorage.getItem('communityId'));
                    //page = this.props.newItemPage
                }
                this.clearState();
                this.props.closeDialog(page);
            }, 200)
        }
    };

    //#region Modal
    Modal = {
        paperModal: {
            backgroundColor: '#1f1f1f',
            padding: '6px',
            width: '45%',
            height: '75%',
            position: 'absolute',
            top: '20%',
            left: '35%'
        },
        stepperModal: {
            height: '10%',
        },
        contentModal: {
            height: '80%',
            width: '65%',
            padding: '20px'
        },
        buttonsModal: {
            justify: 'center',
        },
        hiddenButton: {
            display: 'none'
        },
        visibleButton: {
            marginBottom: '20px'
        },
        visibleDisabledButton: {
            marginBottom: '20px',
            backgroundColor: '#ffffff',
            color: '#bdbdbd'
        }
    }
    //#endregion

    //#region  TABS

    handleChangeIndex = (index) => {
        this.setState({ tabValue: index })
    };

    handleTabChange = (event, newValue) => {
        this.handleChangeIndex(newValue);
    };

    a11yProps = (index) => {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    };

    //#endregion

    //#region  RenderTextFieldWithChips
    handlerChipDelete = (chipText) => {
        let newChipArray = this.state.chipsArray;

        const index = newChipArray.indexOf(chipText);

        if (index !== -1) {
            newChipArray.splice(index, 1);
            this.setState({ chipsArray: newChipArray }, () => this.props.enableButton())
        }

    };


    handlerAddChip = () => {
        const textNewChip = this.state.chipTextFieldActualText;
        const index = this.state.chipsArray.indexOf(textNewChip);
        let chips = this.state.chipsArray;

        if (chips.length < 10) {
            if (textNewChip.length <= 25) {
                if (index === -1 && textNewChip.length > 0) {
                    this.setState({ chipsArray: [...chips, textNewChip], chipTextFieldActualText: '' }, () => this.CheckValues())
                }
            } else {
                const message = 'The identifier should contain less than 25 characters';
                sweetAlert('error', message, 'alert_AddEditActivity_Identifier_Error');
                this.setState({ chipTextFieldActualText: '' })
            }
        } else {
            const message = 'Can´t add more than 10 identifiers per activity';
            sweetAlert('error', message, 'alert_AddEditActivity_Identifier_Error');
        }


        this.props.dispatch(change('ActivityForm', 'Content.identifiers', ''));
    };

    //#endregion

    handleRecurrencyTypeChanged = (selectedOption) => {
        if (selectedOption.target.value) {
            this.setState({ recurrenceType: selectedOption.target.value });
            this.props.dispatch(change('ActivityForm', 'Recurrence.recurrenceType', selectedOption.target.value ? selectedOption.target.value : undefined));
        }

        if (this.state.recurrenceType !== 2) {
            this.setState({ modalSunday: false });
            this.setState({ modalMonday: false });
            this.setState({ modalTuesday: false });
            this.setState({ modalWednesday: false });
            this.setState({ modalThursday: false });
            this.setState({ modalFriday: false });
            this.setState({ modalSaturday: false });
        }
        // else{
        // }
    }


    //#region DatePicker

    GetHoursMinutes = (date, tzName, name = '') => {

        date = this.GetDateChangingTimeZone(date, tzName);

        if (name === 'H') {
            if (date.getHours() === 0)
                return { number: 12, text: date.getHours() }
            else if (date.getHours() > 12)
                return { number: date.getHours() - 12, text: date.getHours() - 12 }
            else
                return { number: date.getHours(), text: date.getHours() }
        } else {
            return { number: date.getMinutes(), text: ('0' + date.getMinutes()).slice(-2) }
        }
    }

    GetHoursMeridem = (date) => {

        date = new Date(date);

        if (date.getHours() >= 0 && date.getHours() <= 11) {
            return 1;
        } else {
            return 2;
        }

    }

    GetUTCDate = (date, name = '') => {


        let currentStartDate = new Date();
        let currentEndDate = new Date();
        let currentDate = new Date(date);


        if (this.state) {
            currentStartDate = this.state.startDate ? new Date(this.state.startDate) : new Date();
            currentEndDate = this.state.endDate ? new Date(this.state.endDate) : new Date();
            currentDate = new Date(date);
        }

        switch (name) {
            case 'date':

                this.setState({
                    startDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), currentStartDate.getHours(), currentStartDate.getMinutes()),
                    endDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), currentEndDate.getHours(), currentEndDate.getMinutes())
                },
                    () => {
                        this.props.dispatch(change('ActivityForm', 'Content.startDate', this.state.startDate))
                        this.props.dispatch(change('ActivityForm', 'Content.endDate', this.state.endDate))
                    }
                )

                break;
            case 'startDate':

                if (currentDate > this.state.endDate) {
                    this.setState({
                        startDate: date,
                        endDate: date
                    },
                        () => {
                            this.props.dispatch(change('ActivityForm', 'Content.startDate', this.state.startDate))
                            this.props.dispatch(change('ActivityForm', 'Content.endDate', this.state.endDate))
                        }
                    );
                } else {
                    this.setState({
                        startDate: date
                    },
                        () => {
                            this.props.dispatch(change('ActivityForm', 'Content.startDate', this.state.startDate))
                        }
                    );
                }

                break;
            case 'endDate':
                const endDate = new Date(date);
                const startDate = new Date(this.state.startDate ? this.state.startDate : '');

                let D = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), endDate.getHours(), endDate.getMinutes())

                if (endDate.getHours() === 0) {
                    const m = moment(D).clone().add(1, 'days');
                    D = new Date(m);

                }


                if (startDate > endDate) {
                    const message = 'the start time of an activity cannot be greater than the end time'
                    sweetAlert('error', message, 'alert_AddEditActivity_StartTime_Error');
                    D = startDate;
                }

                this.setState({
                    endDate: D
                },
                    () => {
                        this.props.dispatch(change('ActivityForm', 'Content.endDate', this.state.endDate))
                    }
                );

                date = D;
                break;
            case 'recurrenceEndDate':
                const prevDate = new Date(date);
                let endRecurrenceDate = new Date(this.state.startDate ? this.state.startDate : '');

                if (date !== null && date.toString().length > 0 && prevDate >= endRecurrenceDate) {
                    if (prevDate.toString() !== 'Invalid Date') {
                        endRecurrenceDate = new Date(prevDate.getFullYear(), prevDate.getMonth(), prevDate.getDate(), 23, 59)
                    }
                }


                this.props.dispatch(change('ActivityForm', 'Recurrence.endDate', endRecurrenceDate));
                this.setState({
                    endRecurrenceDate: endRecurrenceDate
                });
                break;

            default:
                break;
        }
        return date;
    };

    GetDiff = (date1, date2) => {
        return Math.abs(Math.round(((date1.getTime() - date2.getTime()) / 1000) / 60))
    };
    //#endregion

    readImage(e) {
        //Base 64
        let reader = new FileReader();
        const imageSelected = e.target.files[0]

        if (imageSelected === undefined)
            return;

        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = () => {
            const objBase64 = {
                type: imageSelected.type,
                name: imageSelected.name.replace(/[:/#?&@%+~\s]/g, '_'),
                file: reader.result

            }

            this.setState({ selectedDetailsImageUrl: URL.createObjectURL(imageSelected), objBase64selectedDetailsImage: objBase64 }, () => this.CheckValues());

        }
    };

    toDataURL = (url) => {
        var xhr = new XMLHttpRequest();

        xhr.onload = () => {
            var reader = new FileReader();

            reader.onloadend = () => {

                const imgName = `${this.state.imageSearch}_${moment(new Date()).format('YYYY_MM_DD_hh_mm_ss')}`

                const objBase64 = {
                    type: url.substring(url.lastIndexOf(".") + 1),
                    name: imgName.replace(/[:/#?&@%+~\s]/g, '_'),
                    file: reader.result
                }

                this.setState({ objBase64selectedDetailsImage: objBase64 })

            }

            reader.readAsDataURL(xhr.response);
        };

        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();


    }

    handleAddRecurrence = () => {
        if (!this.validateRecurrenceInformation()) {
            this.cleanModal();
        } else {

            sweetAlert('error', 'please select a recurrence type and a valid end date', 'alert_AddEditActivity_RecurrenceType_Error');
        }

    };

    validateRecurrenceInformation = () => {

        let onError = false;

        if (!this.state.recurrenceType ||
            (
                this.state.recurrenceType &&
                this.state.recurrenceType === 2 &&
                (
                    this.state.modalSunday === false &&
                    this.state.modalMonday === false &&
                    this.state.modalTuesday === false &&
                    this.state.modalWednesday === false &&
                    this.state.modalThursday === false &&
                    this.state.modalFriday === false &&
                    this.state.modalSaturday === false
                )
            )
        ) {
            onError = true
        }

        if (!this.state.endRecurrenceDate) {
            onError = true;
        }

        if (!isNaN(this.state.endRecurrenceDate.getMonth()) && this.state.endRecurrenceDate < new Date()) {
            onError = true;
        }

        return onError;
    }

    CheckForValidCaracters = (input) => {
        let pattern = '[0-9]';

        if (input.length > 0) {
            var regex = new RegExp(pattern);
            if (regex.test(input)) {
                return input;
            } else {
                return input.substring(0, input.length - 1);
            }
        } else {
            return input;
        }

    };

    //#region  recurrenceUpdate


    openRecurrentUpdateModal(e, data, index) {
        if (this.props.data && this.props.data.scheduleData) {
            //Old Data Recurrence      
            const oldrecurrenceType = (this.props.data.scheduleData && this.props.data.scheduleData.recurrenceType) ? this.props.data.scheduleData.recurrenceType : undefined;
            const oldmodalSunday = (this.props.data.scheduleData && this.props.data.scheduleData.sunday) ? this.props.data.scheduleData.sunday : false;
            const oldmodalMonday = (this.props.data.scheduleData && this.props.data.scheduleData.monday) ? this.props.data.scheduleData.monday : false;
            const oldmodalTuesday = (this.props.data.scheduleData && this.props.data.scheduleData.tuesday) ? this.props.data.scheduleData.tuesday : false;
            const oldmodalWednesday = (this.props.data.scheduleData && this.props.data.scheduleData.wednesday) ? this.props.data.scheduleData.wednesday : false;
            const oldmodalThursday = (this.props.data.scheduleData && this.props.data.scheduleData.thursday) ? this.props.data.scheduleData.thursday : false;
            const oldmodalFriday = (this.props.data.scheduleData && this.props.data.scheduleData.friday) ? this.props.data.scheduleData.friday : false;
            const oldmodalSaturday = (this.props.data.scheduleData && this.props.data.scheduleData.saturday) ? this.props.data.scheduleData.saturday : false;
            const oldendRecurrenceDate = (this.props.data.scheduleData && this.props.data.scheduleData.endDate) ? new Date(this.props.data.scheduleData.endDate) : this.GetUTCDate(new Date());
            const oldYear = oldendRecurrenceDate.getFullYear();
            const oldMonth = oldendRecurrenceDate.getMonth();
            const oldDate = oldendRecurrenceDate.getDate();

            //Current Data Recurrence      
            const newrecurrenceType = this.state.recurrenceType;
            const newmodalSunday = this.state.modalSunday;
            const newmodalMonday = this.state.modalMonday;
            const newmodalTuesday = this.state.modalTuesday;
            const newmodalWednesday = this.state.modalWednesday;
            const newmodalThursday = this.state.modalThursday;
            const newmodalFriday = this.state.modalFriday;
            const newmodalSaturday = this.state.modalSaturday;
            const newendRecurrenceDate = this.state.endRecurrenceDate ? this.state.endRecurrenceDate : this.GetUTCDate(new Date());
            const newYear = newendRecurrenceDate.getFullYear();
            const newMonth = newendRecurrenceDate.getMonth();
            const newDate = newendRecurrenceDate.getDate();

            if (
                (oldrecurrenceType !== newrecurrenceType) ||
                (oldmodalSunday !== newmodalSunday) ||
                (oldmodalMonday !== newmodalMonday) ||
                (oldmodalTuesday !== newmodalTuesday) ||
                (oldmodalWednesday !== newmodalWednesday) ||
                (oldmodalThursday !== newmodalThursday) ||
                (oldmodalFriday !== newmodalFriday) ||
                (oldmodalSaturday !== newmodalSaturday) ||
                (oldYear !== newYear) ||
                (oldMonth !== newMonth) ||
                (oldDate !== newDate)
            ) {
                this.setState({
                    openModalRecurrenceUpdate: false,
                    recurrenceUpdate: true
                })

                this.clickButtonSave();

            } else if (this.props.data.scheduleData.recurrenceType || this.props.data.scheduleData.recurrencyType) {
                this.setState({ openModalRecurrenceUpdate: true })

            } else {
                this.clickButtonSave();
            }

        } else {
            this.clickButtonSave();
        }
    };

    clickButtonSave = (e, item, c) => {
        setTimeout(() => {

            var link = document.getElementById('save_btn2')
            link.click()

            this.setState({ openModalRecurrenceUpdate: false });
        }, 200);
    };
    //#endregion

    changeDateFormat = (dateFormat) => {
        if (dateFormat) {
            this.setState({ dateFormat: dateFormat });
        }
    }


    changeDateFormatActivity = (dateFormatActivity) => {
        if (dateFormatActivity) {
            this.setState({ dateFormatActivity: dateFormatActivity });
        }
    }

    onChangeDateHandler = (date, name) => {
        if (date && !isNaN(date.getMonth())) {
            this.GetUTCDate(date, name);
        }


        if (date && name && name === 'date') {
            this.setState({ recurrenceObj: { StartDate: date } })
        }
    }

    handleChangeTab = (event, newValue) => {
        this.setState({ translationTab: newValue });
    };

    a11yProps(lng) {
        return {
            id: `vertical-translation-tab-${lng}`,
            'aria-controls': `vertical-tabpanel-${lng}`,
        };
    }

    handleChangeTranslationIndex = (index) => {
        this.setState({ translationTab: index })
    }

    onTranslationsModalClose = () => {
        this.setState({ openTranslationsModal: false, titleEs: '', titleFr: '', descriptionEs: '', descriptionFr: '', })
        this.props.dispatch(change('ActivityForm', 'Content.titleEs', ''));
        this.props.dispatch(change('ActivityForm', 'Content.descriptionEs', ''));
        this.props.dispatch(change('ActivityForm', 'Content.titleFr', ''));
        this.props.dispatch(change('ActivityForm', 'Content.descriptionFr', ''));
    }


    onSaveRecurrenceFormHandler = (recurrenceObj) => {
        this.setState({ openRecurrenceModal: false, recurrenceUpdate: true, recurrenceCleanInfo: false, recurrenceInitialValue: { name: recurrenceObj.customRepeatValue }, recurrenceObj: recurrenceObj }, () => { (this.props.data && this.props.buttonState) && this.props.enableButton() });
    }

    openRecurrenceModal = () => {
        this.setState({ openRecurrenceModal: true },)
    }

    onCloseRecurrenceModal = () => {
        if (this.state.recurrenceCleanInfo)
            this.setState({ openRecurrenceModal: false, RepeatValue: { name: 'Does not repeat' } });
        else
            this.setState({ openRecurrenceModal: false, RepeatValue: this.state.recurrenceInitialValue });
    }

    OnRepeatValueChangeHandler = (e, newItem) => {
        try {
            if (newItem.name !== 'Does not repeat')
                this.setState({ RepeatValue: newItem, openRecurrenceModal: true });
            else
                this.setState({ RepeatValue: newItem, openRecurrenceModal: false });


        } catch (err) { }
    }

    handleRepeatValueOnClose = (e) => {
        try {
            if (e.type === 'click' && !this.state.openRecurrenceModal && this.state.RepeatValue !== 'Does not repeat') {
                this.setState({ openRecurrenceModal: true });
            }

        } catch (err) { }
    }

    onChangeHandler = (e, placeholder) => {
        let timeValue = e.target.value.slice(-2);
        let date = new Date();

        if (placeholder === 'StartH' || placeholder === 'StartM') {
            date = new Date(this.state.startDate);
            if (placeholder === 'StartH') {
                let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
                timeValue = Number(timeValue) > 12 ? e.target.value.slice(-1) : timeValue;

                if ((!Number.isInteger(Number(e.target.value))) || timeValue > 12 || timeValue === 0) {
                    hourObject.number = 1;
                    hourObject.text = '1';
                } else {
                    hourObject.number = Number(timeValue);
                    hourObject.text = timeValue;
                }

                switch (this.state.startMeridem) {
                    case 1:
                        date = date.setHours(hourObject.number === 12 ? 0 : hourObject.number, date.getMinutes(), 0);
                        this.setState({ startHour: hourObject, startDate: new Date(date) });
                        break;
                    case 2:
                        date = date.setHours(hourObject.number === 12 ? 12 : hourObject.number + 12, date.getMinutes(), 0);
                        this.setState({ startHour: hourObject, startDate: new Date(date) });
                        break;
                    default:
                        date = date.setHours(hourObject.number, date.getMinutes(), 0);
                        this.setState({ startHour: hourObject, startDate: new Date(date) });
                        break;
                }

                // if we have hour, minutes and meriedm set, we upd or add the end date
                if (Object.keys(this.state.startMin).length !== 0 && this.state.startMeridem !== 0)
                    this.updateEndDate(this.state.startMeridem === 1 ? 'startAM' : 'startPM', new Date(date));

            }

            if (placeholder === 'StartM') {
                let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
                timeValue = Number(timeValue) > 59 ? e.target.value.slice(-1) : timeValue;

                if ((!Number.isInteger(Number(e.target.value))) || (Number(timeValue) > 59)) {
                    minuteObject.number = 0
                    minuteObject.text = '00';
                } else {
                    minuteObject.number = Number(timeValue);
                    minuteObject.text = ('0' + timeValue).slice(-2);
                }

                date = date.setMinutes(minuteObject.number, 0);
                this.setState({ startMin: minuteObject, startDate: new Date(date) });

                // if we have hour, minutes and meriedm set, we upd or add the end date
                if (Object.keys(this.state.startHour).length !== 0 && this.state.startMeridem !== 0)
                    this.updateEndDate(this.state.startMeridem === 1 ? 'startAM' : 'startPM', new Date(date));

            }

        } else {
            date = new Date(this.state.endDate);
            if (placeholder === 'EndH') {
                let hourObject = this.state.hourSelected ? this.state.hourSelected : {};
                timeValue = Number(timeValue) > 12 ? e.target.value.slice(-1) : timeValue;
                if ((!Number.isInteger(Number(e.target.value))) || timeValue > 12 || timeValue === 0) {
                    hourObject.number = 1;
                    hourObject.text = '1';
                } else {
                    hourObject.number = Number(timeValue);
                    hourObject.text = timeValue;
                }

                if (this.state.endMeridem === 0) {
                    date = date.setHours(hourObject.number, date.getMinutes(), 0);
                    this.setState({ endHour: hourObject, endDate: new Date(date) });
                } else {
                    date = date.setHours(this.state.endMeridem === 1 ? hourObject.number : hourObject.number === 12 ? 1 : hourObject.number + 12, date.getMinutes(), 0);
                    this.setState({ endHour: hourObject, endDate: new Date(date) });
                }
            }

            if (placeholder === 'EndM') {
                let minuteObject = this.state.minuteSelected ? this.state.minuteSelected : {};
                timeValue = Number(timeValue) > 59 ? e.target.value.slice(-1) : timeValue;
                if ((!Number.isInteger(Number(e.target.value))) || (Number(timeValue) > 59)) {

                    minuteObject.number = 0
                    minuteObject.text = '00';
                } else {
                    minuteObject.number = Number(timeValue);
                    minuteObject.text = ('0' + timeValue).slice(-2);
                }

                date = date.setMinutes(minuteObject.number, 0);
                this.setState({ endMin: minuteObject, endDate: new Date(date) });
            }
        }

        (this.props.data && this.props.buttonState) && this.props.enableButton();
    }

    uploadClick = () => {
        const link = document.getElementsByClassName('divContentImageLoader');
        link[0].click();
    }

    async updateEndDate(value, date) {
        let meridem, hours;

        if (date.getHours() >= 11)
            meridem = value === 'startAM' ? 2 : 1;
        else
            meridem = value === 'startAM' ? 1 : 2;


        if (value === 'startPM') {
            meridem = date.getHours() === 23 ? 1 : 2;
        }

        if ((meridem === 1 && Number(date.getHours()) !== 23) || (meridem === 2 && Number(date.getHours()) < 12))
            hours = Number(date.getHours()) === 12 ? 1 : Number(date.getHours() + 1);
        else
            hours = Number(date.getHours()) === 12 ? 1 : Number(date.getHours() - 11);

        date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours() === 23 ? 0 : date.getHours() + 1, date.getMinutes(), 0, 0);

        this.setState({
            endHour: { number: hours, text: hours },
            endMin: { number: Number(date.getMinutes()), text: ('0' + date.getMinutes()).slice(-2) },
            endMeridem: meridem,
            updEndDate: true,
            endDate: date
        });
    }

    setMeridem(value) {

        let date = new Date();
        switch (value) {
            case 'startAM':
                date = this.state.startDate;
                date = date.getHours() >= 12 ? date.setHours(date.getHours() - 12, date.getMinutes(), 0) : date;
                this.setState({ startMeridem: 1, startDate: new Date(date) });
                break;
            case 'startPM':
                date = this.state.startDate;
                date = date.getHours() < 12 ? date.setHours(date.getHours() + 12, date.getMinutes(), 0) : date;
                this.setState({ startMeridem: 2, startDate: new Date(date) });
                break;
            case 'endAM':
                date = this.state.endDate;
                date = date.getHours() > 12 ? date.setHours(date.getHours() - 12, date.getMinutes(), 0) : date;
                this.setState({ endMeridem: 1, endDate: new Date(date) });
                break;
            case 'endPM':
                date = this.state.endDate;
                date = date.getHours() < 12 ? date.setHours(date.getHours() + 12, date.getMinutes(), 0) : date;
                this.setState({ endMeridem: 2, endDate: new Date(date) });
                break;

            default:
                break;
        }

        if ((this.state.startHour.number !== undefined && this.state.startMin.number !== undefined) && (value === 'startAM' || value === 'startPM'))
            this.updateEndDate(value, new Date(this.state.startDate))


        if (this.props.data && this.props.buttonState) this.props.enableButton();

    }

    async setActivityDate(date) {

        const createEndDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), this.state.endDate.getHours(), this.state.endDate.getMinutes())
        this.setState({ startDate: date, endDate: createEndDate, recurrenceObj: { StartDate: date } }, () => { (this.props.data && this.props.buttonState) && this.props.enableButton() });
    }

    CheckValues = () => {

        if (this.props.data) {

            const { translations, category, location, tags, description, hideOnPrinting, title, transportation, imageUrl, maxAttendees } = this.props.data;

            const spanishObj = translations?.find(x => x.languageCode === 'es');
            const frenchObj = translations?.find(x => x.languageCode === 'fr');

            // //Check for every field that could have changed
            if ((this.state.title && this.state.title !== '' && this.state.title !== title)
                || (this.state.description && this.state.description !== '' && this.state.description !== description)
                || (this.state.location && this.state.location !== '' && this.state.location !== location)
                || (this.state.chipsArray && JSON.stringify(this.state.chipsArray) !== JSON.stringify(tags))
                || (this.state.categorySelected?._id !== category?.categoryId)
                // || (this.state.dateStart && new Date(this.state.dateStart).getTime()!== new Date(timeZoneDate).getTime())
                || (this.state.maxAttendees && this.state.maxAttendees !== '' && this.state.maxAttendees !== maxAttendees)
                || (this.state.selectedDetailsImageUrl !== imageUrl)
                || (this.state.transportation !== transportation)
                || (this.state.hideOnPrint !== hideOnPrinting)
                || (spanishObj?.title !== this.state.titleEs)
                || (spanishObj?.description !== this.state.descriptionEs)
                || (frenchObj?.title !== this.state.titleFr)
                || (frenchObj?.description !== this.state.descriptionFr)
            ) {
                (this.props.buttonState) && this.props.enableButton();
            }

        }

    }

    handleSearch = () => {
        const search = this.state.imageSearch;

        if (search && search !== '' && search.length <= 100) {

            this.props.GetPixabyImages(search, 1);
            this.setState({ openSearchModal: true });
        }
    }

    handleSelectImage = (image) => {
        this.setState({ selectedDetailsImageUrl: image, openSearchModal: false }, () => this.CheckValues());
        this.toDataURL(image);
        this.props.ClearImages();
    }
    handleChangeSearch = (newSearch) => {
        this.setState({ imageSearch: newSearch })
    }
    handleResetSearch = () => {
        this.setState({ selectedDetailsImageUrl: '', imageSearch: '' })
    }

    handleCancelImage = () => {
        this.setState({ openSearchModal: false })
        this.props.ClearImages();
    }



    render() {

        let category = undefined;
        let icon = undefined;

        if ((this.props.data && this.props.data._id) && this.props.activityExists === false) {
            this.props.handleActivityExist(true);
        } else if (!(this.props.data && this.props.data._id) && this.props.activityExists === true) {
            this.props.handleActivityExist(false);
        }

        if (
            this.state.categorySelected === undefined &&
            this.props.data &&
            this.props.data.category &&
            this.props.categoryData
        ) {
            category = this.props.categoryData.find(item => item.iconUrl === this.props.data.category.iconUrl);

        }


        let objSetState = {};

        if (category && this.state.categorySelected === undefined) {
            objSetState.categorySelected = category;
        }

        if (icon && this.state.selectedThumbnailIcon === undefined) {
            objSetState.selectedThumbnailIcon = icon;
        }

        if (Object.keys(objSetState).length !== 0) {
            this.setState(objSetState);

            if (objSetState.categorySelected) {
                this.props.dispatch(change('ActivityForm', 'Content.category', category));
            }

            if (objSetState.thumbnailIcon) {
                this.props.dispatch(change('ActivityForm', 'Desing.thumbnailIconObject', icon));
            }
        }

        /* THIS IS WHERE WE VALIDATE WHEN THE INFORMATION IS SAVED */
        if (this.props.isActivitySuccess.success && (this.props.isActivitySuccess.type === ADD_ACTIVITY_SUCCESS || this.props.isActivitySuccess.type === UPDATE_ACTIVITY_SUCCESS)) {
            this.props.closeDialog(1);
        }


        const onArrowClick = (order, placeHolder) => {
            let date = new Date();

            if (placeHolder === 'StartH' || placeHolder === 'StartM') {
                date = new Date(this.state.startDate);
                let startMeridem = this.state.startMeridem;

                if (placeHolder === 'StartH') {
                    let hourObject = this.state.startHour ? this.state.startHour : {};
                    let hour = hourObject.number ? hourObject.number : 1;

                    if (order === 'Up') {
                        if (hour === 11) {
                            startMeridem = startMeridem === 1 ? 2 : 1;
                        }
                        hour = hour === 12 ? 1 : hour + 1;
                    }
                    else {
                        if (hour === 1) {
                            startMeridem = startMeridem === 1 ? 2 : 1;
                        }
                        hour = hour === 1 ? 12 : hour - 1;
                    }

                    hourObject.number = Number(hour);
                    hourObject.text = hour;

                    switch (startMeridem) {
                        case 1:
                            date = date.setHours(hourObject.number === 12 ? 0 : hourObject.number, date.getMinutes(), 0);
                            break;
                        case 2:
                            date = date.setHours(hourObject.number === 12 ? 12 : hourObject.number + 12, date.getMinutes(), 0);
                            break;
                        default:
                            date = date.setHours(hourObject.number, date.getMinutes(), 0);
                            break;
                    }

                    if (this.state.startMeridem !== 0)
                        this.setState({ startMeridem: startMeridem });

                    this.setState({ startHour: hourObject, startDate: new Date(date) });
                }

                if (placeHolder === 'StartM') {
                    let minuteObject = this.state.startMin ? this.state.startMin : {};
                    let minute = minuteObject.number ? minuteObject.number : 0;

                    if (order === 'Up') {
                        minute = minute === 59 ? 0 : minute + 1;
                    }
                    else {
                        minute = minute === 0 ? 59 : minute - 1;
                    }

                    minuteObject.number = Number(minute);
                    minuteObject.text = ('0' + minute).slice(-2);

                    date = date.setMinutes(minuteObject.number, 0);
                    this.setState({ startMin: minuteObject, startDate: new Date(date) });
                }

                // if we have hour, minutes and meriedm set, we upd or add the end date
                if (Object.keys(this.state.startHour).length !== 0 && Object.keys(this.state.startMin).length !== 0 && this.state.startMeridem !== 0)
                    this.updateEndDate(startMeridem === 1 ? 'startAM' : 'startPM', new Date(date));

            } else {
                if (placeHolder === 'EndH' || placeHolder === 'EndM') {
                    date = new Date(this.state.endDate);
                    if (placeHolder === 'EndH') {
                        let hourObject = this.state.endHour ? this.state.endHour : {};
                        let hour = hourObject.number ? hourObject.number : 1;

                        if (order === 'Up') {
                            hour = hour === 12 ? 1 : hour + 1;
                        }
                        else {
                            hour = hour === 1 ? 12 : hour - 1;
                        }

                        hourObject.number = Number(hour);
                        hourObject.text = hour;

                        if (this.state.endMeridem === 0) {
                            date = date.setHours(hourObject.number, date.getMinutes(), 0);
                            this.setState({ endHour: hourObject, endDate: new Date(date) });
                        } else {
                            date = date.setHours(this.state.endMeridem === 1 ? hourObject.number : hourObject.number === 12 ? 1 : hourObject.number + 12, date.getMinutes(), 0);
                            this.setState({ endHour: hourObject, endDate: new Date(date) });
                        }
                    }

                    if (placeHolder === 'EndM') {
                        let minuteObject = this.state.endMin ? this.state.endMin : {};
                        let minute = minuteObject.number ? minuteObject.number : 0;

                        if (order === 'Up') {
                            minute = minute === 59 ? 0 : minute + 1;
                        }
                        else {
                            minute = minute === 0 ? 59 : minute - 1;
                        }

                        minuteObject.number = Number(minute);
                        minuteObject.text = ('0' + minute).slice(-2);

                        date = date.setMinutes(minuteObject.number, 0);

                        this.setState({ endMin: minuteObject, endDate: new Date(date) });
                    }
                }
            }

            (this.props.data && this.props.buttonState) && this.props.enableButton()
        }

        return (
            <div>
                <form  >
                    <Grid container>
                        <Grid item xs={12}>
                            <div className="imgalignrigth-engage appbtn-details-engage">
                                <div id="save_btn2" className="appbtn-engage skybluebtn-engage" onClick={this.props.handleSubmit(this.onSubmitHandler.bind(this))}>
                                    Save
                                </div>
                                <div id="save_btn" className="appbtn-engage skybluebtn-engage" style={{ display: 'none' }} onClick={() => this.openRecurrentUpdateModal()}>
                                    Save
                                </div>
                                <div id='new_recurrence_btn' className='appbtn-engage purplebtn-engage' onClick={() => this.setState({ openModal: true })}>
                                    Recurrence
                                </div>
                                <div id="cancel_btn" className="appbtn-engage redbtn-engage" onClick={() => { this.clearState(); this.props.closeDialog(); }}>
                                    Cancel
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    {this.props.openPreview ?
                        <ActivityPreview
                            themeImage={this.state.selectedTheme}
                            detailsImage={this.state.selectedDetailsImageUrl}
                            thumbnailImage={this.state.selectedDetailsImageUrl}
                            thumbnailIcon={this.state.selectedThumbnailIcon}
                            title={this.state.title}
                            description={this.state.description}
                            transportation={this.state.transportation}
                            location={this.state.location}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            category={this.state.categorySelected}
                        />
                        :
                        undefined
                    }
                    <Grid container style={{ width: '100%', margin: '0', padding: '0' }}>
                        <AppBar position="static" style={{ width: '100%', margin: '0', padding: '0', backgroundColor: '#2a2a2b' }} color="default" elevation={0} classes={{ root: 'Activity10' }} >
                            <Tabs
                                value={this.state.tabValue}
                                onChange={this.handleTabChange}
                                //indicatorColor="transparent"
                                TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                                variant="fullWidth"
                                aria-label="full width tabs community"
                            >
                                <Tab id='Add_Activity_Content_Tab' label="Content" className={(this.state.tabValue === 0) ? "SelectedTabStyle" : "tabStyle"} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                                {
                                    (this.state._id) &&
                                    <Tab id='Add_Activity_Registrees_Tab' label="Registrants" className={(this.state.tabValue === 1) ? "SelectedTabStyle" : "tabStyle"} {...this.a11yProps(2)} disableRipple={true} disableFocusRipple={true} />

                                }
                            </Tabs>
                        </AppBar>
                        <SwipeableViews
                            axis={'x'}
                            index={this.state.tabValue}
                            onChangeIndex={this.handleChangeIndex}
                            className="swipeableViews"
                        >
                            <TabPanel value={this.state.tabValue} index={0} dir={'x'}  >
                                <Grid container style={{ marginTop: '30px' }} justify='space-around'  >
                                    <Grid item xs={12} sm={12} md={4} lg={4} style={{ padding: '0px 10px' }}>
                                        <Grid container direction='column'>
                                            <Grid item xs={12} className='setUpTitleEngage' >
                                                General Info
                                            </Grid>
                                            <Grid item xs={12} >
                                                <Grid container direction='colum' className='setUpGridColum'>
                                                    <Grid item xs={12} style={{ padding: '10px' }}>
                                                        <Field
                                                            name="Content.title"
                                                            label="Title"
                                                            maxLength={20}
                                                            onChange={(e, newItem) => this.setState({ title: newItem })}
                                                            component={renderTextField}
                                                            id='Add_Activity_Title'
                                                            onBlur={() => this.CheckValues()}
                                                        />
                                                        {
                                                            (this.state.title && this.state.title.length > 0) ?
                                                                <Grid item className="characterCount" style={{ textAlign: 'right' }}> {`${this.state.title.length}/50`}</Grid>
                                                                :
                                                                undefined
                                                        }
                                                        {
                                                            (this.state.title && this.state.title.length > 25) ?
                                                                <Grid>
                                                                    <Grid className='errorText'>Title may be abbreviated to 25 characters for printing: </Grid>
                                                                    <Grid item className="characterCount">{`${this.state.title.substring(0, 25)}...`}</Grid>
                                                                </Grid>

                                                                :
                                                                undefined
                                                        }
                                                    </Grid>
                                                    <Grid item xs={12} style={{ padding: '10px' }}>
                                                        <Field
                                                            name="Content.description"
                                                            label="Description"
                                                            rows={4}
                                                            maxLength={150}
                                                            onChange={(e, newItem) => this.setState({ description: newItem })}
                                                            component={renderTextField}
                                                            id='Add_Activity_Description'
                                                            onBlur={() => this.CheckValues()}
                                                        />
                                                        {
                                                            (this.state.description && this.state.description.length > 0) ?
                                                                <Grid item className="characterCount" style={{ textAlign: 'right' }}> {`${this.state.description.length}/150`}</Grid>
                                                                :
                                                                undefined
                                                        }
                                                    </Grid>
                                                    <Grid item xs={12} style={{ padding: '10px' }}>
                                                        {/* <Autocomplete
                                                            id='add_activities_images_dropdown'
                                                            style={{ width: '100%', marginBottom: '1rem' }}
                                                            options={this.props.images ? this.props.images : []}
                                                            value={this.state.selectedDetailsImageObj ? this.state.selectedDetailsImageObj : { name: '' }}
                                                            name="GeneralInfo.Image"
                                                            getOptionSelected={(option, value) => option === value ? true : false}
                                                            getOptionLabel={option => option.name ? option.name : ''}
                                                            renderOption={option => {
                                                                return (
                                                                    <>
                                                                        <Grid item container xs={12} alignItems='center' justifyContent='center' justify='center'>
                                                                            <Grid item>
                                                                                <img
                                                                                    style={{ objectFit: 'scale-down', margin: 'auto' }}
                                                                                    width={'250px'}
                                                                                    heigh={'150px'}
                                                                                    src={option.imageUrl}
                                                                                    alt={option.name}
                                                                                    className='marginAuto'

                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </>
                                                                )
                                                            }}
                                                            clearOnEscape={true}
                                                            onChange={(event, object) => {
                                                                if (object) {
                                                                    this.setState({ selectedDetailsImageObj: object, selectedDetailsImageUrl: object.imageUrl }, () => this.CheckValues());
                                                                    this.props.dispatch(change('ActivityForm', 'Content.Image', object.imageUrl))
                                                                } else {
                                                                    this.setState({ selectedDetailsImageObj: null, selectedDetailsImageUrl: '' }, () => this.CheckValues());
                                                                }
                                                            }}
                                                            renderInput={(params) => {
                                                                return (<>
                                                                    <TextField
                                                                        label='Image'
                                                                        placeholder='Keyword Search'
                                                                        {...params}
                                                                    />
                                                                </>
                                                                )
                                                            }
                                                            }
                                                            popupIcon={
                                                                <ExpandMore style={{ color: 'white' }} />
                                                            }
                                                            closeIcon={
                                                                <Close fontSize="small" style={{ color: 'white' }} />
                                                            }
                                                        /> */}
                                                        <TextField
                                                            name='image_url'
                                                            type='text'
                                                            label='Image'
                                                            placeholder='Image Search'
                                                            fullWidth
                                                            value={this.state.imageSearch}
                                                            onChange={(e) => { this.setState({ imageSearch: e.target.value }) }}
                                                            onKeyDown={e => { if (e && e.keyCode && e.keyCode === 13) { this.handleSearch() } }}
                                                            style={{ paddingRight: '15px' }}
                                                            InputProps={{
                                                                endAdornment:
                                                                    <InputAdornment position='end'>
                                                                        <IconButton onClick={this.handleResetSearch} className="icon_btn"><Clear style={{ color: 'white', opacity: '0.56' }} /></IconButton>
                                                                        <IconButton onClick={this.handleSearch} className="icon_btn"><SearchRounded style={{ color: 'white', fontSize: 30 }} /></IconButton>
                                                                    </InputAdornment>

                                                            }}
                                                            error={this.state.imageSearch.length > 100}
                                                            helperText={this.state.imageSearch.length > 100 && 'The search must contain less than 100 characters'}
                                                        />
                                                        <Grid item container alignContent='center' justifyContent='flex-end' style={{ paddingRight: '15px' }}>
                                                            {
                                                                (this.state?.imageSearch && this.state.imageSearch.length > 0) ?
                                                                    <Grid item className="characterCount"> {`${this.state.imageSearch.length}/100`}</Grid>
                                                                    :
                                                                    undefined
                                                            }
                                                        </Grid>
                                                        <Grid className='helperText' style={{ margin: '1rem 0rem' }}>Type in your image search keyword(s) and click the search icon or press Enter</Grid>
                                                        <RenderImageLoader
                                                            text='Edit'
                                                            imageUrl={this.state.selectedDetailsImageUrl}
                                                            imageName='Details Image'
                                                            onChange={(e) => this.readImage(e, 'selectedDetailsImage')}
                                                            idToSet="Add_Activity_Image"
                                                            id='Add_Activity_Image'
                                                        />

                                                        <Grid item container xs={12} justify='center'>
                                                            <Grid style={{ borderBottom: '1px solid white', cursor: 'pointer' }} onClick={this.uploadClick}>
                                                                <img
                                                                    src='https://engage360.s3.amazonaws.com/Icons/Categories/upload.svg'
                                                                    alt='upload'
                                                                    height={'20px'}
                                                                    width={'20px'}
                                                                />
                                                                <span style={{ color: 'white', fontFamily: 'Gotham-Book', fontSize: '16px', marginLeft: '10px' }}>
                                                                    Upload Custom
                                                                </span>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} style={{ padding: '0px 10px' }}>
                                        <Grid container direction='column'>
                                            <Grid item xs={12}>
                                                <Grid container direction='column'>
                                                    <Grid item xs={12} className='setUpTitleEngage' >
                                                        Logistics
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container direction='colum' className='setUpGridColum'>
                                                            <Grid item container xs={12}>
                                                                {/** NEW START */}
                                                                <Grid item xs={6} className='CommunityId'>
                                                                    Start Time
                                                                </Grid>
                                                                <Grid item container xs={12} justify='space-between'>
                                                                    <Grid item xs={4}>
                                                                        <ActivityChevronList
                                                                            idToSet='Schedule_repair_hr'
                                                                            onArrowClick={onArrowClick}
                                                                            onChangeHandler={this.onChangeHandler}
                                                                            optionSelected={this.state.startHour}
                                                                            onKeyDown={e => { if (e.keyCode === 110) e.preventDefault() }}
                                                                            placeHolder='hr'
                                                                            startend='StartH'
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={1} className="ModalColon">:</Grid>
                                                                    <Grid item xs={4}>
                                                                        <ActivityChevronList
                                                                            idToSet='Schedule_repair_min'
                                                                            onArrowClick={onArrowClick}
                                                                            onChangeHandler={this.onChangeHandler}
                                                                            optionSelected={this.state.startMin}
                                                                            onKeyDown={e => { if (e.keyCode === 110) e.preventDefault() }}
                                                                            placeHolder='min'
                                                                            startend='StartM'
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={3}>
                                                                        <ButtonGroup variant="contained" orientation='vertical' aria-label="outlined primary button group">
                                                                            <Button className={this.state.startMeridem === 1 ? "buttonGroup buttonGroupSelected" : "buttonGroup"} onClick={() => this.setMeridem('startAM')} >AM</Button>
                                                                            <Button className={this.state.startMeridem === 2 ? "buttonGroup buttonGroupSelected" : "buttonGroup"} onClick={() => this.setMeridem('startPM')}>PM</Button>
                                                                        </ButtonGroup>
                                                                    </Grid>
                                                                </Grid>
                                                                {/* END TIME */}
                                                                <Grid item xs={6} className='CommunityId' >
                                                                    End Time
                                                                </Grid>
                                                                <Grid item container xs={12} justify='space-between'>
                                                                    <Grid item xs={4}>
                                                                        <ActivityChevronList
                                                                            idToSet='Schedule_repair_hr'
                                                                            onArrowClick={onArrowClick}
                                                                            onChangeHandler={this.onChangeHandler}
                                                                            optionSelected={this.state.endHour}
                                                                            placeHolder='hr'
                                                                            startend='EndH'
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={1} className="ModalColon">:</Grid>
                                                                    <Grid item xs={4}>
                                                                        <ActivityChevronList
                                                                            idToSet='Schedule_repair_min'
                                                                            onArrowClick={onArrowClick}
                                                                            onChangeHandler={this.onChangeHandler}
                                                                            optionSelected={this.state.endMin}
                                                                            placeHolder='min'
                                                                            startend='EndM'
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={3}>
                                                                        <ButtonGroup variant="contained" orientation='vertical' aria-label="outlined primary button group">
                                                                            <Button className={this.state.endMeridem === 1 ? "buttonGroup buttonGroupSelected" : "buttonGroup"} onClick={() => this.setMeridem('endAM')} >AM</Button>
                                                                            <Button className={this.state.endMeridem === 2 ? "buttonGroup buttonGroupSelected" : "buttonGroup"} onClick={() => this.setMeridem('endPM')}>PM</Button>
                                                                        </ButtonGroup>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    name="Content.location"
                                                                    label="Location"
                                                                    onChange={(e, newItem) => { this.setState({ location: newItem }); }}
                                                                    maxLength={20}
                                                                    component={renderTextField}
                                                                    id='Add_Activity_location'
                                                                    onBlur={() => this.CheckValues()}

                                                                />
                                                                {
                                                                    (this.state.location && this.state.location.length > 0) ?
                                                                        <Grid item className="characterCount" style={{ textAlign: 'right' }}> {`${this.state.location.length}/50`}</Grid>
                                                                        :
                                                                        undefined
                                                                }
                                                            </Grid>

                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <TextField
                                                                    id='Add_activity_max_attendees'
                                                                    label="Seats Available"
                                                                    style={{ width: '100%' }}
                                                                    value={this.state.maxAttendees}
                                                                    onChange={(e) => { this.setState({ maxAttendees: this.CheckForValidCaracters(e.target.value) }) }}
                                                                    onBlur={() => this.CheckValues()}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} style={{ padding: '10px' }}>
                                                                <Field
                                                                    id='Add_Activity_transportation_switch'
                                                                    idToSet='Add_Activity_transportation_switch'
                                                                    name="Content.transportation"
                                                                    label="Transportation Provided"
                                                                    checked={this.state.transportation}
                                                                    onClick={() => {
                                                                        this.setState((prevState) => ({ transportation: !prevState.transportation }), () => this.CheckValues());

                                                                    }}
                                                                    component={renderActivitySwitch}
                                                                    stylesLabel={{ fontSize: '24px', fontFamily: 'Gotham-Book', color: '#F0EFEF' }}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} style={{ marginTop: '2rem' }}>
                                                <Grid container direction='column'>
                                                    <Grid item xs={12} className='setUpTitleEngage' >
                                                        Recurrences
                                                    </Grid>
                                                    <Grid container direction='colum' justify='center' alignItems='center' className='setUpGridColum'>
                                                        <Grid item xs={12} lg={12} style={{ padding: '10px' }}>
                                                            <Field
                                                                name="Content.date"
                                                                labelDate="Date"
                                                                selectedDate={this.state.startDate} //most be an date object is use in both date and time
                                                                onDateChange={(date) => this.setActivityDate(date, 'start')}
                                                                maxLength={20}
                                                                component={renderSingleDatePicker}
                                                                idToSet='add_dining_start_date'
                                                                id='add_dining_start_date'
                                                            />
                                                        </Grid>
                                                        <Grid item container xs={12} lg={12} style={{ padding: '10px' }} alignContent='center' justify='center'>
                                                            <Field
                                                                showStartAdornment={true}
                                                                name="RepeatValue"
                                                                label="Repeats"
                                                                maxLength={20}
                                                                selected={this.state.RepeatValue ? this.state.RepeatValue : { name: 'Does not repeat' }}
                                                                optionsItemsIconsData={this.state.RepeatValueOptions ? this.state.RepeatValueOptions : [{ name: 'Does not repeat' }]}
                                                                onChangeHandler={(e, newItem) => this.OnRepeatValueChangeHandler(e, newItem)}
                                                                onCloseHandler={(e) => this.handleRepeatValueOnClose(e)}
                                                                component={renderSelect}
                                                                diableClear={true}
                                                                idToSet="RepeatValue"
                                                                id='RepeatValue'
                                                            />
                                                        </Grid>
                                                        <Grid id="recurrance-details-label" item xs={12} className="OcurrenceLabel">
                                                            {this.state.recurrenceObj?.OccurrenceLabel ? this.state.recurrenceObj.OccurrenceLabel : ''}
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} style={{ padding: '0px 10px' }}>
                                        <Grid container direction='column'>
                                            <Grid item xs={12} className='setUpTitleEngage' >
                                                Identifiers
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Grid container direction='colum' className='setUpGridColum'>
                                                    <Grid item xs={12} style={{ padding: '10px' }}>
                                                        <Field
                                                            name="Content.identifiers"
                                                            label="Tags"
                                                            maxLength={20}
                                                            value={this.state.chipTextFieldActualText}
                                                            chipsOptions={this.state.chipsArray}
                                                            handlerOnChipDelete={(chipText) => this.handlerChipDelete(chipText)}
                                                            handlerOnClickAddButton={() => this.handlerAddChip()}
                                                            onChange={(e) => this.setState({ chipTextFieldActualText: e.target.value })}
                                                            onKeyDown={e => { if (e && e.keyCode && e.keyCode === 13) { this.handlerAddChip() } }}
                                                            component={renderTextFieldWithChips}
                                                            idToSet="Add_Activity_Tags"
                                                            id='Add_Activity_Tags'
                                                        />
                                                        <Grid className='helperText'>Press Enter after each desired tag description.</Grid>
                                                    </Grid>
                                                    <Grid item xs={12} className='CommunityId' style={{ paddingLeft: '1rem', marginTop: '1rem' }}>
                                                        Category
                                                    </Grid>
                                                    <Grid item container xs={12} style={{ padding: '10px' }}>

                                                        {
                                                            this.props.categoryData && this.props.categoryData.map(c => {
                                                                return (
                                                                    <Grid item container xs={6} sm={4} md={6} lg={4} style={{ padding: '0px 5px 10px 5px' }} key={`category_${c._id}`} id={`category_${c._id}`}>
                                                                        <Grid item container xs={12} className={"cateogryCard"}
                                                                            style={{ backgroundColor: (this.state.categorySelected?.categoryId === c._id || this.state.categorySelected?._id === c._id) ? '#009EDD' : '#454446' }}
                                                                            onClick={() => {
                                                                                this.setState({ categorySelected: c }, () => this.CheckValues());
                                                                                this.props.dispatch(change('ActivityForm', 'Content.category', c));
                                                                            }}
                                                                            alignItems='flex-start' justifyContent='center'
                                                                        >
                                                                            <Grid item container xs={12} justify='center' justifyContent='center'>
                                                                                <img
                                                                                    src={c.iconUrl}
                                                                                    alt={c.name}
                                                                                    width='56px'
                                                                                    height='99px'
                                                                                    className='marginAuto'
                                                                                />
                                                                            </Grid>


                                                                            <Grid item xs={12} className='activity_category'>
                                                                                {c.name}
                                                                            </Grid>

                                                                        </Grid>

                                                                    </Grid>

                                                                )


                                                            })
                                                        }
                                                    </Grid>

                                                    <Grid item xs={12} style={{ padding: '10px' }}>
                                                        <Field
                                                            id='Add_Activity_hide_switch'
                                                            idToSet='Add_Activity_hide_switch'
                                                            name="Content.hideOnPrint"
                                                            label="Hide on print"
                                                            checked={this.state.hideOnPrint}
                                                            onClick={() => this.setState((prevState) => ({ hideOnPrint: !prevState.hideOnPrint }), () => this.CheckValues())}
                                                            component={renderActivitySwitch}
                                                            stylesLabel={{ fontSize: '24px', fontFamily: 'Gotham-Book', color: '#F0EFEF' }}
                                                        />
                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </TabPanel>
                            <TabPanel value={this.state.tabValue} index={1} dir={'x'}>
                                <Grid container style={{ marginTop: '30px' }}>
                                    <Grid item >
                                    </Grid>
                                    <Grid item container xs={12} direction='row'>
                                        {
                                            (this.props.data && this.props.data.attendees) ?
                                                this.props.data.attendees.map(
                                                    (item) => {
                                                        if (item.subscribed === true) {
                                                            return (
                                                                <SimpleCard
                                                                    resident={item}
                                                                    idToSet={`Activity_Attendee_${item._id}`}
                                                                />
                                                            )
                                                        } else
                                                        return (<></>)
                                                    }
                                                )
                                                : undefined
                                        }
                                    </Grid>
                                </Grid>
                            </TabPanel>
                        </SwipeableViews>
                    </Grid>

                    <Fab
                        color='primary'
                        onClick={() => this.setState({ openTranslationsModal: true })}
                        classes={{
                            root: 'fab',
                            primary: "fabColor"
                        }}
                        size="large"
                    >
                        <FontAwesomeIcon
                            icon={faLanguage}
                            color='white'
                            size='2x'
                        />
                    </Fab>





                    {/* // Modal Recurrence Update */}
                    <Modal
                        open={this.state.openModalRecurrenceUpdate}
                        onClose={() => this.setState({ openModalRecurrenceUpdate: false })}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                    >

                        <UpdateRecurrenceConfirmation
                            cancelChanges={() => { this.setState({ openModalRecurrenceUpdate: false }); this.props.closeDialog() }}
                            close={() => this.setState({ openModalRecurrenceUpdate: false })}
                            applyOneOcurrence={() => this.setState({ recurrenceUpdate: false }, this.clickButtonSave())}
                            applyAllOcurrences={() => this.setState({ recurrenceUpdate: true }, this.clickButtonSave())}
                            activity={this.props.data}
                            timeZone={this.props.tzName}
                        />
                    </Modal>

                    <Modal
                        open={this.state.openTranslationsModal}
                        onClose={this.onTranslationsModalClose}
                    >

                        <Paper elevation={3}>
                            <Grid className="translationsModal" >
                                <Grid className="ModalTitle">Add translations</Grid>
                                <Grid item container xs={12} style={{ marginTop: '1rem', marginBotton: '1rem' }}>
                                    <Tabs
                                        value={this.state.translationTab}
                                        onChange={this.handleChangeTab}
                                        aria-label="Translations tab"
                                        className='translationTabs'
                                        TabIndicatorProps={{ style: { backgroundColor: '#009edd' } }}

                                    >
                                        <Tab label="ES" className={(this.state.translationTab === 0) ? "SelectedTranslationTabs" : "translationTab"} {...this.a11yProps(0)} />
                                        <Tab label="FR" className={(this.state.translationTab === 1) ? "SelectedTranslationTabs" : "translationTab"} {...this.a11yProps(1)} />
                                    </Tabs>

                                    <SwipeableViews
                                        axis='x'
                                        index={this.state.translationTab}
                                        onChangeIndex={this.handleChangeTranslationIndex}
                                    >

                                        <TabPanel value={0} index={0} className='translationTabContent'>
                                            <Grid item container xs={12} style={{ marginTop: '1rem' }}>
                                                <Grid item xs={12}>
                                                    <Field
                                                        name="Content.titleEs"
                                                        label="Titulo"
                                                        maxLength={20}
                                                        onChange={(e, newItem) => this.setState({ titleEs: newItem })}
                                                        component={renderTextField}
                                                        id='Add_Activity_Title_es'
                                                    />
                                                    {
                                                        (this.state.titleEs && this.state.titleEs.length > 0) ?
                                                            <Grid item className="characterCount" style={{ textAlign: 'right' }}> {`${this.state.titleEs.length}/50`}</Grid>
                                                            :
                                                            undefined
                                                    }
                                                </Grid>
                                                <Grid item xs={12} style={{ marginTop: '1rem' }}>
                                                    <Field
                                                        name="Content.descriptionEs"
                                                        label="Descripción"
                                                        rows={4}
                                                        maxLength={20}
                                                        onChange={(e, newItem) => this.setState({ descriptionEs: newItem })}
                                                        component={renderTextField}
                                                        id='Add_Activity_Description_ens'
                                                    />
                                                    {
                                                        (this.state.descriptionEs && this.state.descriptionEs.length > 0) ?
                                                            <Grid item className="characterCount" style={{ textAlign: 'right' }}> {`${this.state.descriptionEs.length}/150`}</Grid>
                                                            :
                                                            undefined
                                                    }
                                                </Grid>
                                            </Grid>
                                        </TabPanel>

                                        <TabPanel value={1} index={1} className='translationTabContent'>
                                            <Grid item container xs={12} style={{ marginTop: '1rem' }}>
                                                <Grid item xs={12}>
                                                    <Field
                                                        name="Content.titleFr"
                                                        label="Titre"
                                                        maxLength={20}
                                                        onChange={(e, newItem) => this.setState({ titleFr: newItem })}
                                                        component={renderTextField}
                                                        id='Add_Activity_Title_fr'
                                                    />
                                                </Grid>
                                                <Grid item xs={12} style={{ marginTop: '1rem' }}>
                                                    <Field
                                                        name="Content.descriptionFr"
                                                        label="La description"
                                                        rows={4}
                                                        maxLength={20}
                                                        onChange={(e, newItem) => this.setState({ descriptionFr: newItem })}
                                                        component={renderTextField}
                                                        id='Add_Activity_Description_fr'
                                                    />
                                                </Grid>
                                            </Grid>
                                        </TabPanel>

                                    </SwipeableViews>


                                </Grid>

                                <Grid item container xs={12} alignItems='center' justify='center' style={{ marginTop: '1rem' }}>
                                    <Grid
                                        item container justify='center' alignItems='center'
                                        onClick={() => this.setState({ openTranslationsModal: false })}
                                        className='RepairsModalButtonCancel alingCenter'
                                    >
                                        Cancel
                                    </Grid>
                                    <Grid
                                        item container justify='center' alignItems='center'
                                        onClick={() => this.setState({ openTranslationsModal: false }, () => this.CheckValues())}
                                        className='RepairsModalButtonSchedule alingCenter'
                                    >
                                        Ok
                                    </Grid>
                                </Grid>



                            </Grid>
                        </Paper>

                    </Modal>


                    {
                        //&&  this.state.dateStart
                        (this.state.openRecurrenceModal && this.state.startDate) ?
                            <RecurrenceModal
                                inputObj={this.state.recurrenceObj ? this.state.recurrenceObj : { StartDate: this.state.startDate }}
                                openModal={this.state.openRecurrenceModal}
                                onCloseModalHandler={this.onCloseRecurrenceModal}
                                onSaveFormHandler={this.onSaveRecurrenceFormHandler}
                                selectedRepeatValue={this.state.RepeatValue}
                            />
                            :
                            undefined
                    }

                    <Modal
                        open={this.state.openSearchModal}
                        style={{ borderRadius: '16px' }}
                        onClose={this.handleCancelImage}
                    >

                        <ImagesModal
                            onDone={this.handleSelectImage}
                            onCancel={this.handleCancelImage}
                            currentSearch={this.state.imageSearch}
                            changeSearch={this.handleChangeSearch}
                        />

                    </Modal>

                </form>
            </div>
        );
    };

};




function mapStateToProps(state) {

    const activityForm = state.form ? state.form : undefined;
    const categoryData = (state.categoryReducer && state.categoryReducer.categoryData) ? state.categoryReducer.categoryData.filter(c => c.name !== 'Uncategorized') : [];
    const activityData = (state.activityReducer && state.activityReducer.activityData) ? state.activityReducer.activityData : [];
    const activitySuccess = state.activityReducer;
    const images = (state.activityReducer && state.activityReducer.activitiesImages) ? state.activityReducer.activitiesImages : [];


    return {
        activityForm: activityForm,
        activityData: activityData,
        categoryData: categoryData,
        isActivitySuccess: activitySuccess,
        images
    };
};


export default connect(mapStateToProps, { GetCategoriesByCommunityId, AddActivity, UpdActivity, AddDetailsImage, getCommunityByIdAsync, GetPixabyImages, ClearImages })(reduxForm({
    form: 'ActivityForm',
    validate,
    enableReinitialize: true,
})(AddEditActivityV2));
